import React from "react";
import Link from "gatsby-link";

class Header extends React.Component {
  render() {
    return (
      <header id="header">
        <div className="inner">
          <Link to="/">
            <h1>
              <strong>Glaskunst Seidelmann</strong>
            </h1>
          </Link>

          <p className="tagline">
            Mundgeblasene Unikate, handbemalt – mit Zertifikat.
            <br />
            Eine kleine Auswahl unserer Arbeiten und Kontaktmöglichkeit.
          </p>

          <ul className="icons" style={{ marginTop: "1.2rem" }}>
            <li>
              <a className="icon fa-image" href="#arbeiten">
                <span className="label">Arbeiten</span>
              </a>
            </li>
            <li>
              <a className="icon fa-envelope-o" href="#kontakt">
                <span className="label">Kontakt</span>
              </a>
            </li>
          </ul>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js